/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const LockOpen = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9 8H13V6C13 3.24 15.24 1 18 1C20.76 1 23 3.24 23 6V8H21.1V6C21.1 4.29 19.71 2.9 18 2.9C16.29 2.9 14.9 4.29 14.9 6V8Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10C18 8.9 17.1 8 16 8H15H13.1H6.9H5H4C2.9 8 2 8.9 2 10V20C2 21.1 2.9 22 4 22H16C17.1 22 18 21.1 18 20V10ZM10 17C8.9 17 8 16.1 8 15C8 13.9 8.9 13 10 13C11.1 13 12 13.9 12 15C12 16.1 11.1 17 10 17Z"
    />
  </Icon>
);
